import { WalletOutlined } from '@ant-design/icons';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { createPaymentRowFormSchema } from './createPaymentRowFormSchema.ts';
import { getPaymentRowReferences } from './getPaymentRowReferences.ts';
import { type IPaymentRowWidget } from './IPaymentRowWidget.ts';
import { PaymentRowConfigComponent } from './PaymentRowConfigComponent.tsx';
import { PaymentRowConfigSchema } from './PaymentRowConfigSchema.ts';
import { PaymentRowWidgetComponent } from './PaymentRowWidgetComponent.tsx';
import { PaymentRowWidgetPreviewComponent } from './PaymentRowWidgetPreviewComponent.tsx';

export const PaymentRowWidgetType: IWidgetType<IPaymentRowWidget> = {
  type: WidgetType.PaymentRow,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Voce di Costo',
  icon: <WalletOutlined />,
  supportedSectionTypes: ['BACKOFFICE'],
  hasValue: true,

  formComponent: PaymentRowWidgetComponent,
  createFormSchema: createPaymentRowFormSchema,

  configComponent: PaymentRowConfigComponent,
  configValidator: PaymentRowConfigSchema,

  previewComponent: PaymentRowWidgetPreviewComponent,

  translationSchema: tran.widget({}),

  rules: [RequiredRule],
  getReference: getSimpleWidgetReference(Datatype.Number),
  getSiblingReferences: getPaymentRowReferences,
  alwaysEnabled: true,
};
